//#region IMPORT
import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
  Container,
  Checkbox,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Button as CustomButton } from '../../../../Components/MUIs';
import FilterBottomSheet from '../../../../Components/BottomSheet/FilterBottomSheet';
import FilterFAB from '../../../../Components/Ui/FilterFAB';
import SignatureBottomSheet from '../../../../Components/Ui/SignatureBottomSheet';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
//#endregion

//#region COMPONENT
export default function M_EIS_NEW(props) {
  //#region 변수
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  //#endregion

  return (
    <Container
      sx={{ py: 2, height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      {/* 안내 문구 */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
          보호구 지급 확인
        </Typography>
        <Typography variant="body2" color="text.secondary">
          지급된 보호구를 확인하고, 실제로 받은 보호구를 체크한 후 서명해주세요.
        </Typography>
      </Box>

      {/* 지급된 보호구 목록 */}
      <Box
        sx={{
          mb: 3,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
          지급된 보호구
        </Typography>
        <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
          {props.registeredEquipList.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              지급된 보호구가 없습니다.
            </Typography>
          ) : (
            <Stack spacing={1}>
              {props.registeredEquipList.map((equip, index) => {
                const equipId = equip.issuId?.toString() || '';
                const isSelected =
                  equipId && props.selectedEquips.includes(equipId);
                const isSigned = equip.issuSign === 'Y';

                return (
                  <Card
                    key={equip.issuId || equip.equipId || index}
                    sx={{
                      border: isSelected
                        ? '2px solid #1976d2'
                        : '1px solid #e0e0e0',
                      borderRadius: 2,
                      opacity: isSigned ? 0.6 : 1,
                      pointerEvents: isSigned ? 'none' : 'auto',
                    }}
                  >
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 1,
                        }}
                      >
                        <Checkbox
                          checked={isSelected}
                          onChange={() => props.onEquipToggle(equipId)}
                          disabled={isSigned}
                          size="small"
                          sx={{ p: 0 }}
                        />
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 'bold', flex: 1 }}
                        >
                          {equip.equipNm}
                        </Typography>
                        {isSigned && (
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#57B84D',
                              fontWeight: 'bold',
                              fontSize: '12px',
                            }}
                          >
                            서명 완료
                          </Typography>
                        )}
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 0.5,
                        }}
                      >
                        {equip.reason && (
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ minWidth: 60 }}
                            >
                              지급용도:
                            </Typography>
                            <Typography variant="caption" color="text.primary">
                              {equip.reason}
                            </Typography>
                          </Box>
                        )}
                        {equip.createDate && (
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ minWidth: 60 }}
                            >
                              지급일자:
                            </Typography>
                            <Typography variant="caption" color="text.primary">
                              {equip.createDate.replace('T', ' ')}
                            </Typography>
                          </Box>
                        )}
                        {equip.qty != null && (
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ minWidth: 60 }}
                            >
                              수량:
                            </Typography>
                            <Typography variant="caption" color="text.primary">
                              {equip.qty}
                            </Typography>
                          </Box>
                        )}
                        {equip.remark && (
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ minWidth: 60 }}
                            >
                              비고:
                            </Typography>
                            <Typography variant="caption" color="text.primary">
                              {equip.remark}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                );
              })}
            </Stack>
          )}
        </Box>
      </Box>

      {/* 서명 버튼 */}
      <Box sx={{ mt: 'auto' }}>
        {(() => {
          const hasUnsignedSelected = props.registeredEquipList.some(
            (equip) =>
              equip.issuSign !== 'Y' &&
              props.selectedEquips.includes(equip.issuId?.toString())
          );

          return (
            <CustomButton
              name="서명하기"
              sx={{
                width: '100%',
                height: 48,
                borderRadius: '5px',
                backgroundColor: hasUnsignedSelected ? '#57B84D' : '#BDBDBD',
                color: '#fff',
                '&:hover': {
                  backgroundColor: hasUnsignedSelected ? '#4a9e42' : '#BDBDBD',
                },
                '&:disabled': {
                  backgroundColor: '#BDBDBD',
                  color: '#fff',
                },
              }}
              onClick={props.onSignClick}
              disabled={!hasUnsignedSelected}
            />
          );
        })()}
      </Box>
      {/* 서명 바텀시트 */}
      {bottomSheetState?.type === 'EquipIssuanceSign' && (
        <SignatureBottomSheet
          signatureCanvas={props.signatureCanvas}
          userInfo={props.userInfo}
          signInputs={props.signInputs}
          setSignInputs={props.setSignInputs}
          alarmData={[]}
          signUpload={props.signUpload}
          onSave={() => {
            if (!props.signInputs.mapUrl) {
              dispatch(
                showSnackbar({
                  message: '서명을 완료해주세요.',
                  type: 'warning',
                })
              );
              return;
            }

            props.onSave();
          }}
        />
      )}
      {/* 필터 바텀시트 */}
      {bottomSheetState?.type === 'EquipIssuanceFilter' && (
        <FilterBottomSheet
          searchRef={props.searchRef}
          onSearch={props.onSearch}
          custList={props.custList}
          selectedCustCd={props.selectedCustCd}
          onCustChange={props.onCustChange}
        />
      )}
      {/* FAB 버튼 */}
      <FilterFAB onFilterClick={props.onFilterClick} />
    </Container>
  );
}
